module.exports = __webpack_public_path__ + "static/img/giving.195d74e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/giving.svg
// module id = 816
// module chunks = 0